// import "./dataset-style.scss";
import "react-data-grid/lib/styles.css";

import { CButton, CCard, CCardBody, CCardHeader } from "@coreui/react";
import { useEffect, useState } from "react";
import WhereFilter, {
  AddWhereFilterButton,
  initialWhereFilterValue,
} from "src/reusable/WhereFilter";
import "src/views/products/work-management-ai/project-overview/project-overview.scss";

import PropTypes from "prop-types";

export const RecordFilter = (props) => {
  const [filterRowsReady, setFilterRowReady] = useState([]);

  const setFilterRowIdxReady = (idx, isReady) => {
    let newFilterRowReady = [...filterRowsReady];
    newFilterRowReady[idx] = isReady;
    setFilterRowReady(newFilterRowReady);
  };

  useEffect(() => {
    if (props.hideApplyButton) {
      props.setWhereFilters(props.tempWhereFilters);
    }
  }, [props.tempWhereFilters, props.hideApplyButton]);

  return (
    <CCard style={{ margin: "10px 0px", padding: 10, minWidth: "200px" }}>
      <CCardHeader style={{ padding: "5px 5px" }}>
        <div style={{ float: "left" }}>
          <h5>Filters</h5>
        </div>
        <div style={{ float: "right" }}>
          {!props.hideApplyButton && (
            <CButton
              color="primary"
              size="sm"
              data-testid={`${props.testIdPrefix}-btn-apply`}
              onClick={() => props.setWhereFilters(props.tempWhereFilters)}
              disabled={
                filterRowsReady.length === 0 ||
                filterRowsReady.some((rowReady) => rowReady === false)
              }
            >
              Apply
            </CButton>
          )}
          <CButton
            color="secondary"
            size="sm"
            data-testid={`${props.testIdPrefix}-btn-clear`}
            style={{ marginLeft: "5px" }}
            onClick={() => {
              props.resetFilters();
              setFilterRowReady([]);
            }}
          >
            Clear
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody
        style={{
          padding: "0px 0px",
        }}
      >
        <div
          style={{
            padding: "5px 5px",
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            alignContent: "center",
          }}
        >
          {props.tempWhereFilters.map((value, index) => {
            return (
              <div
                key={index}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <WhereFilter
                  id={props.id}
                  group={props.group}
                  fields={props.fields}
                  includeHeader={index === 0}
                  value={value}
                  addFilterEnabled={false}
                  onValidFilter={(newValue) => {
                    if (
                      JSON.stringify(newValue) !==
                      JSON.stringify(props.tempWhereFilters[index])
                    ) {
                      let newWhereFilters = [...props.tempWhereFilters];
                      newWhereFilters[index] = newValue;
                      props.setTempWhereFilters(newWhereFilters);
                    }
                  }}
                  onAddFilter={() => {
                    let newWhereFilters = [...props.tempWhereFilters];
                    newWhereFilters.splice(
                      index + 1,
                      0,
                      initialWhereFilterValue,
                    );
                    props.setTempWhereFilters(newWhereFilters);
                  }}
                  onRemoveFilter={() => {
                    let newWhereFilters = [...props.tempWhereFilters];
                    newWhereFilters.splice(index, 1);
                    filterRowsReady.splice(index, 1);
                    props.setTempWhereFilters(newWhereFilters);
                  }}
                  setFilterReady={(isReady) => {
                    setFilterRowIdxReady(index, isReady);
                  }}
                />
              </div>
            );
          })}
          <div className="add-where-filter-button" style={{ marginTop: "3px" }}>
            <AddWhereFilterButton
              onAddFilter={() => {
                let newWhereFilters = [...props.tempWhereFilters];
                newWhereFilters.push(initialWhereFilterValue);
                props.setTempWhereFilters(newWhereFilters);
                props.setWhereFilters(newWhereFilters);
              }}
            />
          </div>
        </div>
      </CCardBody>
    </CCard>
  );
};

RecordFilter.propTypes = {
  whereFilters: PropTypes.array.isRequired,
  setWhereFilters: PropTypes.func.isRequired,
  tempWhereFilters: PropTypes.array.isRequired,
  setTempWhereFilters: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  group: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  hideApplyButton: PropTypes.bool,
  resetFilters: PropTypes.func,
  testIdPrefix: PropTypes.string,
};

RecordFilter.defaultProps = {
  whereFilters: [],
  tempWhereFilters: [],
  resetFilters: () => {
    console.log("reset filters default arg, should be overloaded.");
  },
  hideApplyButton: false, // Default to false to maintain existing behavior
  testIdPrefix: "filter",
};
